import React from 'react';

export const BankSvg = (props) => {

  const { width, height, color } = props;

  if (color) {
    return (
      <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="9" y="9" width="4.5" height="12" fill={color} />
        <rect x="15.75" y="9" width="4.5" height="12" fill={color} />
        <rect x="22.5" y="9" width="4.5" height="12" fill={color} />
        <path d="M17.5 0.288675C17.8094 0.110043 18.1906 0.110042 18.5 0.288675L30.3564 7.13397C31.2424 7.64553 30.8795 9 29.8564 9H6.14359C5.12049 9 4.75756 7.64553 5.64359 7.13397L17.5 0.288675Z" fill={color} />
        <rect x="6" y="21" width="24" height="3" rx="1" fill={color} />
        <rect x="4.5" y="24" width="27" height="3" rx="1" fill={color} />
      </svg>
    )
  }

  return (
    <svg width={width ?? "36"} height={height ?? "36"} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5996_18809)">
        <path d="M3 16H33V34H3V16Z" fill="#566F75" />
        <path d="M2 34H34C35.104 34 36 34.896 36 36H0C0 34.896 0.896 34 2 34Z" fill="#C2CCCE" />
        <path d="M18 23C16.343 23 15 24.343 15 26V32H21V26C21 24.343 19.657 23 18 23Z" fill={window?.settings?.secondary_color ?? '#04333b'} />
        <path d="M3 21H7V32H3V21ZM9 21H13V32H9V21ZM29 21H33V32H29V21ZM23 21H27V32H23V21Z" fill="#C2CCCE" />
        <path d="M2 32H34V34H2V32Z" fill="#9EACB0" />
        <path d="M36 11L18 0L0 11H36Z" fill="#566F75" />
        <path d="M18 2.40039L2 12.0004V16.0004H34V12.0004L18 2.40039Z" fill="#C2CCCE" />
        <path d="M3 19H7V21H3V19ZM9 19H13V21H9V19ZM23 19H27V21H23V19ZM29 19H33V21H29V19Z" fill="#566F75" />
        <path d="M1 12H35V17H1V12Z" fill="#C2CCCE" />
        <path d="M36 12C36 12.552 35.553 13 35 13H1C0.448 13 0 12.552 0 12V11C0 10.448 0.448 10 1 10H35C35.553 10 36 10.448 36 11V12ZM36 18C36 18.552 35.553 19 35 19H1C0.448 19 0 18.552 0 18V17C0 16.448 0.448 16 1 16H35C35.553 16 36 16.448 36 17V18Z" fill="#9EACB0" />
        <path d="M13 32H23V34H13V32Z" fill="#E7EBEB" />
        <path d="M11 34H25V36H11V34Z" fill="#F3F5F5" />
      </g>
      <defs>
        <clipPath id="clip0_5996_18809">
          <rect width="36" height="36" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}